import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Container } from '../styled/containers';

export const StickyWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
`;

export const Alert = styled.div`
  width: 100%;
  position: relative;
  bottom: 0px;
  z-index: 11;
  background-color: ${({ theme }) => theme.palette.darkBackground};
  color: ${({ theme }) => theme.palette.white};
  border-top: ${({ theme }) => `1px solid ${theme.palette.borderDark}`};

  p {
    margin-bottom: 5px;
  }

  a,
  button {
    svg {
      color: ${({ theme }) => theme.palette.white};
    }

    &:focus,
    &:hover {
      svg {
        color: ${({ theme }) => theme.palette.linkHoverOnDarkBG};
      }
    }
  }
`;

export const BannerWrapper = styled(Container)`
  position: relative;
  padding: ${({ theme }) => theme.spacing.standard};

  p:last-child {
    margin-bottom: 0;
  }
`;

export const AlertTextWrapper = styled.div`
  width: calc(100% - ${({ theme }) => theme.spacing.large});
  padding-left: ${({ theme }) => theme.spacing.small};
  border-left: ${({ theme }) => `4px solid ${theme.palette.white}`};
`;

export const BannerTitleWrapper = styled.div`
  display: flex;
`;

export const Icon = styled(SVG)`
  display: block;
  width: 18px;
  height: 18px;
`;

export const WarningIcon = styled(Icon)`
  margin: 3px ${({ theme }) => theme.spacing.standard} 0 0;
`;
export const Close = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.spacing.small};
  top: ${({ theme }) => theme.spacing.standard};
  padding: 4px;
  background: transparent;
  border: none;
  line-height: 1;
  font-size: ${({ theme }) => theme.fontsize.larger};

  ${Icon} {
    color: ${({ theme }) => theme.palette.white};
  }
`;
